// Mock data para SendHapy Courier Landing Page

export const mockTrackingData = {
  'SH123456': {
    trackingNumber: 'SH123456',
    status: 'En tránsito',
    location: 'Miami, FL - Centro de Distribución',
    estimatedDelivery: '15 de Enero, 2025',
    history: [
      { date: '10 Ene 2025', time: '14:30', status: 'Paquete recibido en Miami', location: 'Miami, FL' },
      { date: '11 Ene 2025', time: '09:15', status: 'En proceso de documentación', location: 'Miami, FL' },
      { date: '12 Ene 2025', time: '16:45', status: 'En tránsito a Costa Rica', location: 'En vuelo' }
    ]
  },
  'SH789012': {
    trackingNumber: 'SH789012',
    status: 'Entregado',
    location: 'San José, Costa Rica',
    estimatedDelivery: 'Entregado el 8 de Enero, 2025',
    history: [
      { date: '03 Ene 2025', time: '10:00', status: 'Paquete recibido en Miami', location: 'Miami, FL' },
      { date: '05 Ene 2025', time: '08:30', status: 'Llegó a Costa Rica', location: 'San José, CR' },
      { date: '06 Ene 2025', time: '14:20', status: 'En proceso de aduana', location: 'San José, CR' },
      { date: '08 Ene 2025', time: '11:45', status: 'Entregado exitosamente', location: 'San José, CR' }
    ]
  },
  'SH345678': {
    trackingNumber: 'SH345678',
    status: 'Pendiente de recolección',
    location: 'Oficina SendHapy - San José',
    estimatedDelivery: 'Disponible para recoger',
    history: [
      { date: '07 Ene 2025', time: '09:00', status: 'Paquete recibido en Miami', location: 'Miami, FL' },
      { date: '09 Ene 2025', time: '15:30', status: 'Llegó a Costa Rica', location: 'San José, CR' },
      { date: '10 Ene 2025', time: '10:15', status: 'Liberado de aduana', location: 'San José, CR' },
      { date: '11 Ene 2025', time: '08:00', status: 'Disponible en oficina', location: 'San José, CR' }
    ]
  }
};

export const testimonials = [
  {
    id: 1,
    name: 'María González',
    location: 'San José, Costa Rica',
    rating: 5,
    comment: 'Mi paquete llegó rápido y sin problemas. Excelente servicio y muy profesionales.',
    date: 'Hace 2 semanas'
  },
  {
    id: 2,
    name: 'Carlos Ramírez',
    location: 'Heredia, Costa Rica',
    rating: 5,
    comment: 'Puedo ver dónde está mi paquete en todo momento. El rastreo en tiempo real es increíble.',
    date: 'Hace 1 mes'
  },
  {
    id: 3,
    name: 'Ana Solís',
    location: 'Alajuela, Costa Rica',
    rating: 5,
    comment: 'Muy responsables y confiables. Ya he enviado varios paquetes y siempre llegan bien.',
    date: 'Hace 3 semanas'
  },
  {
    id: 4,
    name: 'Roberto Mata',
    location: 'Cartago, Costa Rica',
    rating: 5,
    comment: 'El mejor servicio de courier. Precio justo y atención personalizada.',
    date: 'Hace 1 semana'
  },
  {
    id: 5,
    name: 'Laura Jiménez',
    location: 'Puntarenas, Costa Rica',
    rating: 5,
    comment: 'Recibí notificaciones en cada paso del proceso. Muy transparentes.',
    date: 'Hace 2 meses'
  },
  {
    id: 6,
    name: 'Diego Vargas',
    location: 'Limón, Costa Rica',
    rating: 5,
    comment: 'Compro en Amazon y siempre uso SendHapy. Nunca me han fallado.',
    date: 'Hace 3 días'
  }
];

export const benefits = [
  {
    id: 1,
    icon: 'Package',
    title: 'Entregas Rápidas',
    description: 'Recibe tus paquetes en tiempo récord desde Miami hasta tu casa en Costa Rica.'
  },
  {
    id: 2,
    icon: 'DollarSign',
    title: 'Precio Real',
    description: 'Sin cargos ocultos. Pagas exactamente lo que cotizamos desde el inicio.'
  },
  {
    id: 3,
    icon: 'MapPin',
    title: 'Rastreo en Tiempo Real',
    description: 'Sigue tu paquete en cada momento con nuestro sistema de tracking actualizado.'
  },
  {
    id: 4,
    icon: 'Headphones',
    title: 'Atención Personalizada',
    description: 'Soporte directo por WhatsApp. Respondemos todas tus dudas al instante.'
  },
  {
    id: 5,
    icon: 'Shield',
    title: 'Seguridad Garantizada',
    description: 'Tus paquetes están protegidos desde que los recibimos hasta la entrega final.'
  },
  {
    id: 6,
    icon: 'Clock',
    title: 'Horario Flexible',
    description: 'Entregas coordinadas según tu disponibilidad. Tú decides cuándo recibir.'
  }
];

export const casilleroInfo = {
  address: {
    firstName: 'SendHapy',
    lastName: 'Tu Nombre',
    street: '10171 NW 58TH ST',
    suite: 'UNIT 10',
    city: 'Doral',
    state: 'FL',
    zip: '33178',
    country: 'United States',
    phone: '+1 (305) 298-4073'
  },
  benefits: [
    'Dirección en Miami lista para usar',
    'Recepción segura de todos tus paquetes',
    'Notificaciones automáticas al llegar',
    'Consolidación de múltiples paquetes',
    'Entrega directa hasta tu casa en Costa Rica'
  ],
  pricing: {
    per100g: '$1.20',
    perLb: '$5.40',
    perKg: '$12.00',
    consolidation: 'Gratuita'
  }
};

export const faqData = [
  {
    id: 'faq-1',
    question: '¿Cómo funciona el servicio de casillero?',
    answer: 'Te proporcionamos una dirección en Miami donde puedes recibir todas tus compras online. Una vez que tu paquete llega a nuestro warehouse, te notificamos y lo enviamos a Costa Rica.'
  },
  {
    id: 'faq-2',
    question: '¿Cuánto tiempo tarda en llegar mi paquete?',
    answer: 'El tiempo promedio es de 7-10 días hábiles desde que recibimos tu paquete en Miami hasta la entrega en Costa Rica. Los envíos express pueden llegar en 3-5 días.'
  },
  {
    id: 'faq-3',
    question: '¿Qué artículos no pueden ser enviados?',
    answer: 'No podemos enviar artículos prohibidos como: armas, explosivos, sustancias ilegales, líquidos inflamables, baterías de litio sueltas, y productos perecederos.'
  },
  {
    id: 'faq-4',
    question: '¿Cuánto cuesta el envío dentro de Costa Rica?',
    answer: 'El costo de entrega depende de la zona: Dentro del GAM: ₡2700 para paquetes menores a 5 kg. Más de 5 kg dentro del GAM: envío gratis. Fuera del GAM: ₡3500 aproximadamente mediante servicio de mensajería nacional.'
  },
  {
    id: 'faq-5',
    question: '¿El envío puede salir gratis?',
    answer: 'Sí. Si tu paquete pesa más de 5 kg, la entrega dentro del GAM es completamente gratis.'
  },
  {
    id: 'faq-6',
    question: '¿Cómo se calcula el costo de mi paquete?',
    answer: 'El costo del envío se calcula según el peso total del paquete en kilogramos. Solo pagas por el peso real de tu paquete.'
  },
  {
    id: 'faq-7',
    question: '¿Cómo sé cuándo llegó mi paquete?',
    answer: 'Te notificaremos directamente por WhatsApp o mensaje cuando tu paquete esté listo para entrega o retiro.'
  }
];

export const stats = [
  { number: '5000+', label: 'Paquetes Entregados' },
  { number: '99.8%', label: 'Tasa de Satisfacción' },
  { number: '7-10', label: 'Días Promedio' },
  { number: '24/7', label: 'Soporte WhatsApp' }
];
